import { render, staticRenderFns } from "./DoctorMaster.vue?vue&type=template&id=3a4bd02b&"
import script from "./DoctorMaster.vue?vue&type=script&lang=js&"
export * from "./DoctorMaster.vue?vue&type=script&lang=js&"
import style0 from "./DoctorMaster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports